import { FC, ElementType } from 'react';
import { BoxProps, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';


type Props<RootComponent extends ElementType = 'div'> = BoxProps<RootComponent>;

export const FullscreenLayout: FC<Props> = ({ sx, children, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100dvh"
      zIndex={theme.zIndex.modal}
      color="primary"
      pt="env(safe-area-inset-top)"
      sx={sx}
      {...props}
    >
      <Box p={2} height="100%">
        {children}
      </Box>
    </Box>
  );
};
